import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  invictusBgVideo: '.js-invictus-video',
  bgVideo: '.js-invictus-wave'
}

class InvictusBgVideo {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.bgVideo = this.element.querySelector(SELECTORS.bgVideo)

    this.init()
  }

  init() {
    this.registerEvents()
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.ELEMENT_IN_VIEWPORT, elem => { this.playVideo(elem) })
  }

  playVideo(elem) {
    if (this.element === elem.target) this.bgVideo.play()
  }
}

export default {
  selector: SELECTORS.invictusBgVideo,
  Source: InvictusBgVideo
}
